import { Button, FormInstance } from "antd";
import { useCallback, useState } from "react";
import { ScheduleModal } from "./components/ScheduleModal";

export type ScheduleEmailOptions = {
  enabledUntilAccountClosed?: boolean;
  enabledOnOccurrences?: boolean;
  enabledOnEndDate?: boolean;
};

type ScheduleEmailProps = {
  form: FormInstance;
  initialData: any;
  disabled: boolean;
  isLoading: boolean;
  onSchedule: (values: any) => void;
  options?: ScheduleEmailOptions;
};

export const ScheduleEmail = ({ form, initialData, disabled, isLoading, onSchedule, options }: ScheduleEmailProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const onClick = useCallback(async () => {
    try {
      await form.validateFields();

      setOpen(true);
    } catch {}
  }, [form]);

  return (
    <>
      <Button shape="round" disabled={disabled} loading={isLoading} className="ml-2" onClick={onClick}>
        Schedule Send
      </Button>

      <ScheduleModal
        open={open}
        setOpen={setOpen}
        initialData={initialData}
        form={form}
        onSchedule={onSchedule}
        options={options}
      />
    </>
  );
};
